export default __webpack_public_path__ + "static/media/sounds/clpl_passage_instructions_Alyx.mp3";